import * as React from 'react'

import {
    Stack,
    Box,
    Button
} from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'

import {HashLink as Link } from "react-router-hash-link";

import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import LocationCityIcon from '@mui/icons-material/LocationCity';


import { InformationComponent, InformationContent, IconsDiv, Logo, LogoDiv, InformationText, SearchDiv, TextContent, TextLogo, TextComponent } from './styles';

import LogoIcon from '../../../assets/images/logo/MarcaSetraBHbrancaeazul.png'
import Icon1 from '../../../assets/images/icons/ICONES-PEQUENOS-v2.png'
import Icon2 from '../../../assets/images/icons/ICONES-PEQUENOS-2-v2.png'

interface TopHeaderProps {
    reference?: any;
    title?: any;
}

const Information: React.FC<TopHeaderProps> = ({ reference, title }) => {

    const matches = useMediaQuery('(max-width:800px)');

    return (
        <InformationComponent>
            <InformationContent>
                <LogoDiv>
                    <Logo src={LogoIcon} height={matches ? "70px" : "100px"}/>
                </LogoDiv>
            </InformationContent>
        </InformationComponent>
    );
}

export { Information }